import React from 'react';
import { Form, Select, DatePicker, Modal } from '@block/plug';
import { datejs } from '@block/utils';
import { doAction, compareDate } from '@utils/index';
import { PlugFormProps } from '@src/types/components';
import { Card } from '../../../components';
import Url from '../url';

interface Props {
  getRef: (ref: React.RefObject<Form>, idx?: number) => void;
  index: number;
  onDelete: (idx: number) => void;
  onChange: (formData: DefaultAny, index: number, formRef: React.RefObject<Form>) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  data: DefaultAny;
}
interface State {
  reasonChidStatus: boolean;
}
class OutOfWorks extends React.Component<Props, State> {
  formRef: React.RefObject<Form>;

  constructor(props: Props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      reasonChidStatus: false,
    };
  }

  async componentDidMount() {
    const { getRef, index } = this.props;
    getRef?.(this.formRef, index);
    this.handleSetData(this.props);
  }

  componentWillReceiveProps(props: Props) {
    this.handleSetData(props);
  }

  handleSetData = (props: Props) => {
    const { data = {} } = props;
    let { reason } = data;
    this.formRef.current?.setFieldsValue(data);
    if (reason) {
      this.setState({ reasonChidStatus: !reason });
      reason = reason || '';
      const [reasonParent, reasonChid] = reason.split('-') || [];
      this?.formRef?.current?.setFieldsValue?.({
        reasonParent,
        reasonChid,
        reasonParentIdx: reasonParent,
        reasonChidIdx: reasonChid,
      });
    }
  };

  handleDelete = () => {
    const { onDelete, index } = this.props;

    // 使用 Modal.confirm 进行二次确认
    Modal.confirm({
      title: '删除警告',
      message: '确定要删除该记录吗？',
      onOk() {
        // 用户点击确认，执行删除
        if (typeof onDelete === 'function') {
          onDelete(index);
        }
      },
    });
  };

  handleFetchSelectData = async (params) => {
    const data = await doAction(Url.getOutOfWorkType, params);
    return data;
  };

  handleFieldValueChange: PlugFormProps['onFieldValueChange'] = (code, value, formValue, params) => {
    const ref = this.formRef.current;
    const { onChange, index } = this.props;
    if (code === 'reasonParentIdx') {
      this.setState({ reasonChidStatus: !value });
      ref?.setFieldsValue({
        reasonChidIdx: null,
        reasonChid: null,
        reason: null,
      });
    }
    if (code === 'reasonChidIdx') {
      const { reasonParent } = ref.getFieldsValueIncludeHide();
      ref?.setFieldsValue({
        reason: `${reasonParent}-${params?.label}`,
      });
    }
    if (code === 'startDate') {
      const startDate = value ? datejs(value).set('date', 1).valueOf() : null;
      ref?.setFieldsValue({
        startDate,
      });
      const { endDate } = ref.getFieldsValueIncludeHide();
      if (compareDate(value, endDate)) {
        ref.clearValidateStatus(['endDate']);
      } else {
        ref?.validateFields(['endDate']);
      }
    }
    if (code === 'endDate') {
      const endDate = value ? datejs(value).set('date', 1).valueOf() : null;
      ref?.setFieldsValue({
        endDate,
      });
    }
    const formData = ref.getFieldsValueIncludeHide();
    if (typeof onChange === 'function') onChange(formData, index, this.formRef);
  };

  // <span className="base-form__flex">

  //             <span className="base-form__line" />
  //           </span>
  render() {
    const { reasonChidStatus } = this.state;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return (
      <Card onDelete={this.handleDelete}>
        <Form
          ref={this.formRef}
          labelWidth="120px"
          onFieldValueChange={this.handleFieldValueChange}
          className="outOfWorks__card"
        >
          <Form.Item labelWidth={0}>
            <span className="base-form__subtitle">歇业描述</span>
          </Form.Item>

          <Form.Item
            formItemKey="reasonParentIdx"
            labelInValue={false}
            formItemLabel="reasonParent"
            span={7}
            required
            message="不能为空"
            label="歇业类型："
            labelWidth={0}
          >
            <Select
              toFormItem
              keyField="value"
              labelField="label"
              filterable={false}
              onFetchData={() =>
                this.handleFetchSelectData({
                  level: 1,
                  parentId: null,
                })
              }
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.outOfWorks__card'),
              }}
            />
          </Form.Item>
          <Form.Item
            formItemKey="reasonChidIdx"
            span={4}
            labelInValue={false}
            formItemLabel="reasonChid"
            required
            message="不能为空"
            labelWidth={0}
          >
            <Select
              toFormItem
              keyField="value"
              labelField="label"
              filterable={false}
              disabled={reasonChidStatus}
              onFetchData={async () => {
                const { reasonParent } = this.formRef.current.getFieldsValueIncludeHide();
                const data = await this.handleFetchSelectData({
                  level: 1,
                  parentId: null,
                });
                const reasonParentValue = data.filter((item) => item.label === reasonParent)[0] || {};
                return this.handleFetchSelectData({
                  level: 2,
                  parentId: reasonParentValue.value,
                });
              }}
              placeholder="请选择"
              loadingMessage="正在搜索..."
              notFoundMessage="无数据"
              popLayer={{
                getContainer: () => document.querySelector('.outOfWorks__card'),
              }}
            />
          </Form.Item>

          <Form.Item
            formItemKey="startDate"
            span={7}
            offset={2}
            required
            message="不能为空"
            label="起止时间："
            labelWidth={0}
          >
            <span className="base-form__flex">
              <DatePicker
                toFormItem
                format="YYYY-MM"
                valueFormat="timestamp"
                placeholder="开始时间"
                popLayer={{
                  getContainer: () => document.querySelector('.outOfWorks__card'),
                }}
              />
              <span className="base-form__line" />
            </span>
          </Form.Item>
          <Form.Item
            className="base-form__space"
            formItemKey="endDate"
            span={4}
            labelWidth={0}
            rules={[
              { required: true, message: '不能为空' },
              {
                validator(rule, value, callback) {
                  const { startDate } = self.formRef.current.getFieldsValueIncludeHide();
                  const endDate = datejs(value).toDate().getTime();
                  if (startDate && endDate < datejs(startDate).toDate().getTime()) {
                    callback('结束时间不能小于开始时间');
                  }
                  callback();
                },
              },
            ]}
          >
            <DatePicker
              toFormItem
              format="YYYY-MM"
              valueFormat="timestamp"
              placeholder="结束时间"
              popLayer={{
                getContainer: () => document.querySelector('.outOfWorks__card'),
              }}
            />
          </Form.Item>
        </Form>
      </Card>
    );
  }
}
export default OutOfWorks;
